<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Prompt girişi</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
 
    <div class="modal-body">

      <form [formGroup]="definitionForm">
        <div class="modal-body">
    
       
    
          <div class="form-group">
            <label>Prompt giriniz</label>
            <textarea class="form-control" formControlName="prompt" rows="20"></textarea>
          </div>
    
    
    
          
          
        </div>
    
        <div class="modal-footer">
          <button type="reset" class="btn grey btn-outline-secondary btn-lg"
            (click)="close()">Kapat</button>
          <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
            <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
            Kaydet</button>
        </div>
      </form>

</div>